import { bool, func, node, string } from "prop-types";
import React from "react";
import { twMerge } from "tailwind-merge";

import { withTabNavigation } from "@hoc/withTabNavigation";

const ListItem = withTabNavigation("li");

const TopBarItem = props => {
  const {
    children,
    className,
    isDisabled,
    isSelected,
    isSelectedHoverable,
    onClick,
    ...restProps
  } = props;
  return (
    <ListItem
      className={twMerge(
        "inline-block px-2 py-1 rounded-sm",
        "text-sm/4 uppercase tracking-px font-semibold whitespace-nowrap",
        "transition duration-300",
        "max-smallMobile:px-1 max-smallMobile:text-xs/4",
        isSelected ? "text-white bg-primaryDark" : "text-primaryDarkAccent",
        !isSelected && !isDisabled
          ? "hover:bg-primaryDarkAccent/10 hover:duration-150 cursor-pointer"
          : "cursor-default",
        isSelected &&
          isSelectedHoverable &&
          "hover:bg-primaryDarkAccent/10 hover:duration-150 hover:text-black cursor-pointer",
        className
      )}
      onClick={onClick}
      {...restProps}
    >
      {children}
    </ListItem>
  );
};

TopBarItem.propTypes = {
  children: node,
  className: string,
  isDisabled: bool,
  isSelected: bool,
  isSelectedHoverable: bool,
  onClick: func,
};

export default TopBarItem;
